import { ICountriesResponse } from "../../api/get/getCountries";
import rawCountryData from "../constants/rawCountryData";

const initializedCountries = rawCountryData.flatMap((country) => ({
  name: country[0],
  isoCode: country[2].toString().toUpperCase(),
  dialCode: country[3],
  displayName: `${country[2].toString().toUpperCase()} | +${country[3]}`,
  priority: country[5] || 0,
}));

export const getIsoCodeByCallingCode = (
  dialCode: string,
  country: string = ""
) => {
  if (country !== "" && (dialCode === "1" || dialCode === "7")) {
    return initializedCountries
      .find((c) => !!c && c.dialCode === dialCode && c.name === country)
      ?.isoCode.toString();
  }
  return initializedCountries
    .find((c) => !!c && c.dialCode === dialCode)
    ?.isoCode.toString();
};

export const getDisplayNameByIsoCode = (isoCode: string) =>
  initializedCountries
    .find((c) => !!c && c.isoCode === isoCode)
    ?.displayName.toString();

export const getIsoCodeByDisplayName = (displayName: string) =>
  initializedCountries.find((c) => !!c && c.displayName === displayName)
    ?.isoCode;

export const getCountryCodeByIsoCode = (isoCode: string) =>
  initializedCountries
    .find((c) => !!c && c.isoCode === isoCode)
    ?.dialCode.toString();

export const getCountryCodeByCountryName = (name: string) =>
  initializedCountries.find((c) => !!c && c.name === name)?.isoCode.toString();

export const getDialCodeByCountryName = (name: string) =>
  initializedCountries.find((c) => !!c && c.name === name)?.dialCode.toString();

export const getFormattedCountryList = (countries: ICountriesResponse[]) => {
  const newCountryList = countries.map((country) =>
    initializedCountries.find((c) => c.name === country.country)
  );
  return newCountryList.filter((item) => item);
};
